export default __webpack_public_path__ + "static/media/SAS Alert Tone 6.9c98a91c.wav";